<template>
  <div id="publishing-eference-add">
    <ipub-model :title="'Edit Reference'"
                width="700px"
                :visable="isVisable"
                :confirmText="params.id?'Save':'Add'"
                @confirm="confirm"
                @cancel="cancel">
      <ipub-form ref="reference-add-form"
                 :model="params"
                 :rules="rules">
        <ipub-form-item prop="content"
                        label="Reference">
          <ipub-editor :height="300"
                       v-model.trim="params.content" />
        </ipub-form-item>
      </ipub-form>
    </ipub-model>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  props: {
    isVisable: {
      type: Boolean,
      default: false,
    },
    inputData: {
      type: Object,
      default () {
        return {}
      }
    },
  },
  data () {
    return {
      params: {},
      rules: {},
    }
  },
  computed: {
    ...mapGetters({
      language: 'getLanguage',
      journalId: 'getJournalId',
    })
  },
  watch: {
    isVisable (val) {
      if (!val) {
        this.params = {}
      } else {
        this.params = Object.assign(this.params, this.inputData)
      }
    }
  },
  mounted () {
    this.getRules()
  },
  methods: {
    async confirm () {
      const flag = this.$refs['reference-add-form'].validate()
      if (flag) {
        this.$message.success({ title: 'Success', content: 'This Reference has been saved!' })
        this.$emit('confirm', this.params)
      }
    },
    preview () {

    },
    cancel () {
      this.$emit('cancel')
    },
    getRules () {
      this.rules = {
        content: [
          {
            required: true,
            message:
              'Affiliation' +
              this.LANGUAGE[this.language].noEmpty
          }
        ],
      }
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
